import DetailedReport from './Report';

export default DetailedReport;
